import { AxiosRequestConfig, AxiosResponse } from 'axios'

import apiClient from '@core/api/client'

export const moodsService = {
	/**
	 * Get all moods
	 */
	getMoods(config?: AxiosRequestConfig): Promise<AxiosResponse> {
		return apiClient.get('/types/moods', config)
	},
}

export default moodsService
